import styled from 'styled-components';

import { Box } from 'components/Box';
import { breakpoints, gutterWidth, maxWidth } from 'theme';

export const PageContent = styled(Box)<{ $centered?: boolean }>`
  ${(props) =>
    props.$centered &&
    `
    width: 100%;
    max-width: ${maxWidth[2]}px;
    padding: 0 ${gutterWidth / 2}px;
    margin: 0 auto;
    @media (min-width: ${breakpoints[2]}) {
      padding: 0 ${gutterWidth}px;
    }
  `}
`;
